/* ==========================================================================
   Savwinch mega menu flow layer

   The Wave header runs in `hover` mode, where the reveal is pure CSS :hover
   with no JavaScript at all. That gives zero open delay, zero close grace, no
   diagonal bridge, and no touch handling.

   This script takes over the open/close decision. It sets html.sav-mm, which
   makes sav-mega-menu.css neutralise the raw :hover reveal and re-key it to
   [data-sav-mm-open]. If this script never runs, the class is never added and
   the original CSS behaviour still applies, so the menu cannot go dark.

   The panels themselves are Wave's own native blocks (mega-menu-builder >
   layout > link-list / group). This file never touches their markup or layout,
   so re-editing a panel in the theme editor cannot break it.

   Loaded once from layout/theme.liquid; self-guards on window.__savMegaMenu.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__savMegaMenu) return;
  window.__savMegaMenu = true;

  var OPEN_DELAY = 110; // dwell before a cold open, so pass-through does not fire
  var CLOSE_DELAY = 260; // grace after leaving, so diagonal moves survive
  var SCROLL_CLOSE = 80; // px of scroll before an open panel is dismissed

  var ROOT_SELECTOR = '.xo-menu-horizontal-base--hover';
  var ITEM_SELECTOR = '.xo-menu-horizontal-base__item';
  var LINK_SELECTOR = '.xo-menu-horizontal-base__link';
  var PANEL_SELECTOR = '.xo-menu-horizontal-base__mega-menu, .xo-menu-horizontal-base__sub-menu';

  var openItem = null;
  var openTimer = null;
  var closeTimer = null;
  var pendingItem = null;
  var scrollAnchor = 0;
  var touchArmed = null; // trigger whose panel was opened by a tap, awaiting a second tap
  var suppressClick = null; // trigger whose next click must not navigate
  var suppressTimer = null;

  document.documentElement.classList.add('sav-mm');

  /* ---------------------------------------------------------------------- */

  function hasPanel(item) {
    if (!item) return false;

    var mega = item.querySelector(':scope > .xo-menu-horizontal-base__mega-menu');
    if (mega) {
      // Already cloned in by <xo-mega-menu>.
      if (mega.children.length > 0 || mega.hasAttribute('xo-section-id')) return true;

      // Not cloned yet. The component only clones on the header's mouseenter or
      // a 1s requestIdleCallback, so an early hover would otherwise be read as
      // "no panel" and silently ignored until the pointer moved away and back.
      // The source template is in the DOM from first paint, so ask that instead.
      var index = mega.getAttribute('xo-index');
      var name = mega.getAttribute('xo-name') || 'header-mega-menu';
      if (index !== null) {
        var sel =
          'template[xo-mega-menu-name="' + name + '"][xo-mega-menu-index="' + index + '"]';
        if (document.querySelector(sel)) return true;
      }
    }

    return !!item.querySelector(':scope > .xo-menu-horizontal-base__sub-menu');
  }

  function trigger(item) {
    return item ? item.querySelector(':scope > ' + LINK_SELECTOR) : null;
  }

  function clearTimers() {
    if (openTimer) {
      clearTimeout(openTimer);
      openTimer = null;
    }
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    pendingItem = null;
  }

  function open(item) {
    if (!item || item === openItem) return;

    // Only a swap gets the instant treatment. A cold open keeps the stagger,
    // so setting this before the first open would kill the animation entirely.
    if (openItem) {
      close(openItem);
      document.documentElement.classList.add('sav-mm-active');
    }

    openItem = item;
    item.setAttribute('data-sav-mm-open', '');

    var t = trigger(item);
    if (t) t.setAttribute('aria-expanded', 'true');

    scrollAnchor = window.scrollY;
  }

  function close(item) {
    if (!item) return;
    item.removeAttribute('data-sav-mm-open');

    var t = trigger(item);
    if (t) t.setAttribute('aria-expanded', 'false');


    if (openItem === item) {
      openItem = null;
      if (touchArmed && item.contains(touchArmed)) touchArmed = null;
    }
  }

  function closeAll() {
    clearTimers();
    var open_ = document.querySelectorAll('[data-sav-mm-open]');
    for (var i = 0; i < open_.length; i++) close(open_[i]);
    openItem = null;
    touchArmed = null;
    document.documentElement.classList.remove('sav-mm-active');
  }

  function scheduleOpen(item) {
    if (!hasPanel(item)) {
      // Drop any armed open first. Without this, sweeping across a panel-owning
      // item on the way to a panel-less one (nav index 3, Installations) leaves
      // its timer running, and a panel appears 110ms later under a pointer that
      // has already moved on.
      if (openTimer) {
        clearTimeout(openTimer);
        openTimer = null;
      }
      pendingItem = null;

      // Hovering a plain link should dismiss whatever is open.
      if (openItem) scheduleClose();
      return;
    }
    if (item === openItem) {
      clearTimers();
      return;
    }

    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    // Cold open pays the dwell. Swapping between panels is instant.
    var delay = openItem ? 0 : OPEN_DELAY;
    pendingItem = item;

    if (openTimer) clearTimeout(openTimer);
    openTimer = setTimeout(function () {
      openTimer = null;
      if (pendingItem === item) open(item);
      pendingItem = null;
    }, delay);
  }

  function scheduleClose() {
    if (openTimer) {
      clearTimeout(openTimer);
      openTimer = null;
      pendingItem = null;
    }
    if (closeTimer) clearTimeout(closeTimer);

    closeTimer = setTimeout(function () {
      closeTimer = null;
      closeAll();
    }, CLOSE_DELAY);
  }

  /* ---------------------------------------------------------------------- */

  function init(root) {
    if (!root || root.__savBound) return;
    root.__savBound = true;

    root.addEventListener('pointerover', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      var item = event.target.closest(ITEM_SELECTOR);
      if (!item || !root.contains(item)) return;

      // Only top-level items own a panel.
      var top = item.closest(ITEM_SELECTOR);
      while (top && top.parentElement && top.parentElement.closest(ITEM_SELECTOR)) {
        top = top.parentElement.closest(ITEM_SELECTOR);
      }
      scheduleOpen(top);
    });

    root.addEventListener('pointerout', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      var to = event.relatedTarget;
      if (to && root.contains(to)) return;
      if (to && openItem && openItem.contains(to)) return;
      scheduleClose();
    });

    // Touch and pen: first tap opens, second tap follows the link.
    root.addEventListener(
      'pointerdown',
      function (event) {
        if (!event.pointerType || event.pointerType === 'mouse') return;

        var link = event.target.closest(LINK_SELECTOR);
        if (!link) return;

        var item = link.parentElement;
        if (!item || !hasPanel(item)) return;
        if (touchArmed === link) return; // second tap, let it navigate

        event.preventDefault();
        // preventDefault on pointerdown suppresses the compatibility mouse
        // events, but whether it also cancels the click is inconsistent across
        // mobile browsers. Arm an explicit guard rather than trusting it: on
        // iPad Safari a leaked click would navigate away from the page the
        // user was only trying to open a menu on.
        suppressClick = link;
        if (suppressTimer) clearTimeout(suppressTimer);
        suppressTimer = setTimeout(function () {
          suppressClick = null;
          suppressTimer = null;
        }, 700);

        closeAll();
        open(item);
        touchArmed = link;
      },
      { passive: false }
    );

    root.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) return;
        var link = event.target.closest(LINK_SELECTOR);
        if (link !== suppressClick) return;
        suppressClick = null;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    // Keyboard: tabbing into an item opens its panel.
    root.addEventListener('focusin', function (event) {
      var item = event.target.closest(ITEM_SELECTOR);
      if (!item) return;
      var top = item;
      while (top.parentElement && top.parentElement.closest(ITEM_SELECTOR)) {
        top = top.parentElement.closest(ITEM_SELECTOR);
      }
      if (!hasPanel(top)) {
        closeAll();
        return;
      }
      clearTimers();
      open(top);
    });

    root.addEventListener('focusout', function (event) {
      var to = event.relatedTarget;
      if (to && root.contains(to)) return;
      scheduleClose();
    });

  }

  /* ---- global escape hatches ------------------------------------------- */

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !openItem) return;
    var t = trigger(openItem);
    closeAll();
    if (t && typeof t.focus === 'function') t.focus();
  });

  window.addEventListener(
    'scroll',
    function () {
      if (!openItem) return;
      if (Math.abs(window.scrollY - scrollAnchor) > SCROLL_CLOSE) closeAll();
    },
    { passive: true }
  );

  window.addEventListener('blur', closeAll);

  document.addEventListener('click', function (event) {
    if (!openItem) return;
    if (!event.target.closest(ROOT_SELECTOR)) closeAll();
  });

  /* ---- boot ------------------------------------------------------------- */

  function boot() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Panels are cloned in lazily by <xo-mega-menu>, and the theme editor
  // reloads header sections in place.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      closeAll();
      boot();
    });
  }
})();
